import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();


function get (payload) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/password-forgot`,payload,options)
        .then(response => {
            return response.data;
        });
}

function add (reset) {
    const payload = jsona.serialize({
        stuff: reset,
        includeNames: null
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/password-reset`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}


export default {
    get,
    add,
};

